function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.function.bind.js";
import React from 'react';
import { Autocomplete, Chip, TextField, makeStyles } from '@applyboard/ui-components';
import { ChevronDownOutlineIcon } from '@applyboard/ui-icons';
var useStyles = makeStyles({
  inputRoot: {
    minHeight: '40px',
    height: 'auto'
  },
  tag: {
    maxWidth: 'calc(100% - 72px)',
    margin: '3px 12px 3px -8px'
  }
});
export function DropdownMultiField(props) {
  var autocompleteStyles = useStyles();
  return /*#__PURE__*/React.createElement(Autocomplete, {
    options: props.options,
    value: props.options.filter(function (option) {
      return props.value.includes(option.value);
    }),
    onChange: function onChange(_e, selectedOptions) {
      props.onChange(selectedOptions.map(function (item) {
        return item.value;
      }));
    },
    openOnFocus: true,
    getOptionLabel: function getOptionLabel(option) {
      return option === null || option === void 0 ? void 0 : option.label;
    },
    renderTags: function renderTags(selectedOptions, getTagProps) {
      return selectedOptions.map(function (option, index) {
        return (
          /*#__PURE__*/
          // eslint-disable-next-line react/jsx-key
          React.createElement(Chip, _extends({
            size: "small",
            label: option.label
          }, getTagProps({
            index: index
          })))
        );
      });
    },
    renderInput: function renderInput(inputProps) {
      return /*#__PURE__*/React.createElement(TextField, _extends({}, inputProps, {
        label: props.label,
        variant: "outlined",
        error: props.error,
        helperText: props.helperText,
        required: props.required,
        style: {
          height: 'auto'
        }
      }));
    },
    freeSolo: false,
    mt: props.mt,
    mb: props.mb,
    mr: props.mr,
    ml: props.ml,
    fullWidth: true,
    popupIcon: /*#__PURE__*/React.createElement(ChevronDownOutlineIcon, null),
    disabled: props.disabled,
    limitTags: props.limitTags,
    multiple: true,
    classes: {
      inputRoot: autocompleteStyles.inputRoot,
      tag: autocompleteStyles.tag
    }
  });
}